/** Serialize full-page saves without blocking saves for other pages. */
export function createPageSaveQueue() {
  const pending = new Map<string, Promise<unknown>>()

  return function enqueue<T>(pageId: string, save: (isLatest: () => boolean) => Promise<T>): Promise<T> {
    const previous = pending.get(pageId) ?? Promise.resolve()
    const result = previous.catch(() => undefined).then(() => save(() => pending.get(pageId) === result))
    pending.set(pageId, result)

    const cleanup = () => {
      if (pending.get(pageId) === result) pending.delete(pageId)
    }
    // Handle both outcomes so a failed save neither blocks the queue nor creates
    // an unhandled rejection in the cleanup chain.
    void result.then(cleanup, cleanup)
    return result
  }
}
